import { render, staticRenderFns } from "./PackingListIndex.vue?vue&type=template&id=8001744e&"
import script from "./PackingListIndex.vue?vue&type=script&lang=js&"
export * from "./PackingListIndex.vue?vue&type=script&lang=js&"
import style0 from "./PackingListIndex.vue?vue&type=style&index=0&id=8001744e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports